
import 'pages/settings/add-fields/add-fields-edit-block.tag'
import md5 from 'blueimp-md5/js/md5.min.js'
riot.tag2('company-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#persons/companies"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новая компания\' : item.name || \'Редактирование компании\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#company-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#company-edit-contacts">Контакты</a></li>\n      <li><a data-toggle="tab" href="#company-edit-orders">Заказы</a></li>\n      <li if="{item.customFields &amp;&amp; item.customFields.length}"><a data-toggle="tab" href="#company-edit-fields">Доп. информация</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="company-edit-home">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="name" type="text" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.fullname}">\n                <label class="control-label">Полное наименование</label>\n                <input class="form-control" name="fullname" type="text" value="{item.fullname}">\n                <div class="help-block">{error.fullname}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.inn}">\n                <label class="control-label">ИНН</label>\n                <input class="form-control" name="inn" type="text" value="{item.inn}">\n                <div class="help-block">{error.inn}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.kpp}">\n                <label class="control-label">КПП</label>\n                <input class="form-control" name="kpp" type="text" value="{item.kpp}">\n                <div class="help-block">{error.kpp}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.phone}">\n                <label class="control-label">Телефон</label>\n                <input class="form-control" name="phone" type="text" value="{item.phone}">\n                <div class="help-block">{error.phone}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.email}">\n                <label class="control-label">E-mail</label>\n                <input class="form-control" name="email" type="text" value="{item.email}">\n                <div class="help-block">{error.email}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.address}">\n                <label class="control-label">Адрес</label>\n                <input class="form-control" name="address" type="text" value="{item.address}">\n                <div class="help-block">{error.address}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Логин</label>\n                <input class="form-control" name="username" type="text" value="{item.username}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Пароль</label>\n                <input class="form-control" name="password" type="password" value="{item.password}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.note}">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                <div class="help-block">{error.note}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-contacts">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="contacts" add="{addModal(&quot;persons-list-select-modal&quot;)}" cols="{contactsCols}" rows="{item.contacts}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="lastName">{[row.lastName, row.firstName, row.secondName].join(\' \')}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-orders">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="orders" remove-toolbar="true" cols="{ordersCols}" rows="{item.orders}" handlers="{handlersOrders}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="amount">{row.amount}</datatable-cell>\n                  <datatable-cell class="{handlers.orderText.colors[row.status]}" name="status">{handlers.orderText.text[row.status]}</datatable-cell>\n                  <datatable-cell class="{handlers.deliveryText.colors[row.deliveryStatus]}" name="deliveryStatus">{handlers.deliveryText.text[row.deliveryStatus]}</datatable-cell>\n                  <datatable-cell name="note">{row.note}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-fields" if="{item.customFields &amp;&amp; item.customFields.length}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.loader = false;
self.item = {};

self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.rules = {
    name: 'empty',
    email: {
        rules: [{
            type: 'email'
        }]
    }
};

self.contactsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.ordersCols = [{ name: 'id', value: '#' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'amount', value: 'Сумма' }, { name: 'status', value: 'Статус заказа' }, { name: 'deliveryStatus', value: 'Статус доставки' }, { name: 'note', value: 'Примечание' }];

self.orderText = {
    text: {
        Y: 'Оплачен', N: 'Не оплачен', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
    },
    colors: {
        Y: 'bg-success', N: 'bg-danger', K: 'bg-warning', P: null, W: null, C: null, T: null
    }
};

self.deliveryText = {
    text: {
        Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
    },
    colors: {
        Y: 'bg-success', N: 'bg-danger', M: null, P: null
    }
};

self.handlersOrders = {
    orderText: self.orderText,
    deliveryText: self.deliveryText
};

self.addModal = function (modal) {
    return function () {
        var _this = this;

        modals.create(modal, {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {
                _this.value = _this.value || [];

                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                var ids = _this.value.map(function (item) {
                    return item.id;
                });

                items.forEach(function (item) {
                    if (ids.indexOf(item.id) === -1) _this.value.push(item);
                });

                self.update();
                this.modalHide();
            }
        });
    };
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.reload = function () {
    observable.trigger('companies-edit', self.item.id);
};

self.submit = function (e) {

    if (self.item && self.item.password && self.item.password.trim() === '') delete self.item.password;else self.item.password = md5(self.item.password);

    var params = self.item;
    self.error = self.validation.validate(params, self.rules);

    if (!self.error) {
        API.request({
            object: 'Company',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Компания сохранена!', style: 'popup-success' });
                self.item = response;
                self.item.password = new Array(8).join(' ');
                self.update();
                if (self.isNew) riot.route('/persons/companies/' + self.item.id);
                observable.trigger('companies-reload');
            }
        });
    }
};

observable.on('companies-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.update();

    API.request({
        object: 'Company',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.item.password = new Array(8).join(' ');
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

observable.on('companies-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = {};
    self.update();
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/persons/company-edit.tag